<template>
	<div>
		<v-skeleton-loader v-if="loading" type="text" />
		<!-- <l-tooltip v-else top :disabled="!$slots['tooltip'] && !tooltip">
			<template v-slot:activator="{ on, attrs }"> -->
		<l-autocomplete :items="items" :label="label" v-bind="$attrs" v-on="$listeners">
			<!-- Forward all named slots -->
			<template v-for="slot of Object.keys($slots)" :slot="slot">
				<slot :name="slot" />
			</template>
			<!-- Forward all scoped slots -->
			<template v-for="slot of Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
				<slot :name="slot" v-bind="scope" />
			</template>
		</l-autocomplete>
		<!-- </template>
			<span>
				<slot name="tooltip">{{ tooltip }}</slot>
			</span>
		</l-tooltip> -->
	</div>
</template>
<script>
import LAutocomplete from '@/components/base/LAutocomplete.vue';
// import LTooltip from '@/components/base/LTooltip.vue';

export default {
	name: 'ModelAutocomplete',
	components: { LAutocomplete },
	props: {
		model: {
			type: Function,
			required: true,
		},
		optionName: {
			type: String,
			required: false,
		},
		match: {
			type: Array,
			required: false,
		},
		tooltip: {
			type: String,
			required: false,
		},
		label: {
			type: String,
			required: false,
		},
		filter: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			items: [],
			loading: false,
		};
	},
	computed: {
		selectedItems: {
			get() {
				return this.$attrs.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {
		async refresh() {
			this.loading = true;
			this.items = await this.model.getArrayByFilter({
				optionName: this.optionName ? this.optionName : 'none',
				match: this.match,
				filter: this.filter ? { 'meta.archived': false, ...this.filter } : { 'meta.archived': false },
			});
			this.loading = false;
		},
	},
	watch: {
		match: {
			deep: true,
			handler: function () {
				this.refresh();
			},
		},
	},
	mounted() {
		this.refresh();
	},
};
</script>
